<div class="flex flex-col gap-2 w-full">
  <label for="searchFieldDropdown" class="text-sm font-normal text-blue-300"
    >Buscar por</label
  >

  <div class="flex items-center gap-0 w-full max-w-search-container">
    <!-- Dropdown "Buscar por" usando app-dropdown -->
    <div
      class="search-select-wrapper w-search-select min-w-search-select max-w-search-select flex-none"
    >
      <app-dropdown
        id="searchFieldDropdown"
        [items]="searchFieldOptions"
        [useAvatar]="false"
        [placeholder]="'Buscar por'"
        (selectItem)="onFieldChange($event.value)"
      ></app-dropdown>
    </div>

    <!-- Input adaptativo (texto o fecha) - siempre visible -->
    @if (selectedField()?.inputType === 'date') {
      <!-- Input de fecha usando app-input-date -->
      <div
        class="search-date-wrapper w-search-input min-w-search-input max-w-search-input flex-none"
      >
        <app-input-date
          [id]="'searchDate'"
          [label]="'Búsqueda'"
          (changed)="onDateChange($event)"
        ></app-input-date>
      </div>
    } @else if (selectedField()?.inputType === 'select') {
      <!-- Select dropdown for predefined options -->
      <div
        class="search-select-value-wrapper w-search-input min-w-search-input max-w-search-input flex-none"
      >
        <div class="input">
          <label class="input-label-item" for="searchValueDropdown"
            >Búsqueda</label
          >
          <app-dropdown
            id="searchValueDropdown"
            [items]="currentSelectOptions()"
            [useAvatar]="false"
            [placeholder]="currentPlaceholder()"
            (selectItem)="onSelectValueChange($event.value)"
            class="search-select-input"
          ></app-dropdown>
        </div>
      </div>
    } @else {
      <!-- Input de texto usando app-input-text -->
      <div
        class="search-text-wrapper w-search-input min-w-search-input max-w-search-input flex-none"
      >
        <app-input-text
          [formControl]="textControl"
          [label]="'Búsqueda'"
        ></app-input-text>
      </div>
    }

    <!-- Botón Buscar (icono circular) -->
    <div class="ml-2 flex-shrink-0">
      <app-button
        label=""
        leftIcon="icon-chevron-derecha-blanco"
        [type]="ButtonTypeEnum.PRIMARY"
        [size]="ButtonSizeEnum.MD"
        (handleClick)="executeSearch()"
        class="icon-buscar-btn"
      ></app-button>
    </div>
  </div>
</div>
